function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#1DA1F2"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.473 10.286c-1.457 0-2.638 1.153-2.638 2.575 0 .202.023.399.068.587a7.55 7.55 0 0 1-5.437-2.69c-.227.38-.357.822-.357 1.294 0 .893.466 1.682 1.174 2.144a2.675 2.675 0 0 1-1.195-.322v.032c0 1.248.91 2.289 2.116 2.525a2.705 2.705 0 0 1-1.191.044 2.633 2.633 0 0 0 2.464 1.79A5.375 5.375 0 0 1 9.2 19.366a5.49 5.49 0 0 1-.63-.036 7.597 7.597 0 0 0 4.044 1.157c4.852 0 7.505-3.925 7.505-7.328 0-.112-.003-.223-.008-.333a5.296 5.296 0 0 0 1.317-1.334 5.37 5.37 0 0 1-1.515.406 2.594 2.594 0 0 0 1.16-1.425 5.36 5.36 0 0 1-1.676.625 2.664 2.664 0 0 0-1.925-.813z",
  fill: "#FFFFFE"
});

var SvgTwitterRedesign = function SvgTwitterRedesign(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "14df33a8cb5d18bff3b83e072ccb55b9.svg";
export { SvgTwitterRedesign as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/twitter-redesign.svg
// module id = null
// module chunks = 